import qs from 'qs';

const PollsRunProgram = {
    namespaced: true,

    state: {
        pollsRunProgramData: [],
    },

    getters: {
        pollsRunProgramData (state) {
            return state.pollsRunProgramData;
        },
    },

    mutations: {

        /**
         * Установить значение pollsRunProgram
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['pollsRunProgramData'] = items;
        },

        /**
         * Обновить значение элемента pollsRunProgram
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['pollsRunProgramData'][index] = item;
        },

        /**
         * Добавить значение элемента pollsRunProgram
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['pollsRunProgramData'].push(item);
        },

        /**
         * Удалить элемент из pollsRunProgram
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['pollsRunProgramData'] = state['pollsRunProgramData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по pollsRunProgram
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPollsRunProgramData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollsRunProgram,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам программ получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN pollsRunProgram.js | getPollsRunProgramData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по шаблонам программ!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по pollsRunProgram
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        getPostPollsRunProgramData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollsRunProgram,
                    }),
                }).then(response => { 
                    // Если редактирование
                     commit('setArr', {
                        items: response.data
                    }),
                    resolve();
                    dispatch('loading/isLoading', false, {root:true});
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN pollsRunProgram.js | savePollsRunProgramData : ' + err);
                        reject(err);
                });
            })
        },
 
        /**
         * Удаление анкет по программе
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePollsData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.removePollsRunProgram,
                    }),
                }).then(response => (
                     
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Шаблон программ успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении шаблона программ!'),
                    console.log('ERROR IN pollsRunProgram.js | removePollsRunProgramData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default PollsRunProgram;





// WEBPACK FOOTER //
// ./src/store/modules/pollsRunProgram.js